import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    handoutUserListLoading: false,
    handoutUserListSuccess: {},
    handoutUserListError: '',
    getHandoutUserLoading: false,
    getHandoutUserSuccess: {},
    getHandoutUserError: '',
    createHandoutUserLoading: false,
    createHandoutUserSuccess: {},
    createHandoutUserError: '',

    handoutUserDetailsLoading: false,
    handoutUserDetailsSuccess: {},
    handoutUserDetailsError: '',

    adminUserList: [],

    courseHandoutListLoading: false,
    courseHandoutListSuccess: {},
    courseHandoutListError: "",

    courseHandoutDetailsLoading: false,
    courseHandoutDetailsSuccess: {},
    courseHandoutDetailsError: "",
    courseHandoutStatusList: [],



    reviewHandoutListLoading: false,
    reviewHandoutListSuccess: {},
    reviewHandoutListError: "",

    courseByHandoutList: [],


    handoutViewLoading: false,
    handoutViewSuccess: {},
    handoutViewError: ""



}

export const handoutUserSlice = createSlice({
    name: 'handout',
    initialState,
    reducers: {

        resetHandoutuserDetails: (state, action) => {
            state.createHandoutUserSuccess = {}
            state.handoutUserDetailsSuccess = {};
            state.courseHandoutDetailsSuccess = {}
        },

        setHandoutUserListLoading: (state, action) => {
            state.handoutUserListLoading = true;
            state.handoutUserListSuccess = null;
            state.handoutUserListError = '';
        },
        setHandoutUserListSuccess: (state, action) => {
            state.handoutUserListLoading = false;
            state.handoutUserListSuccess = action.payload;
            state.handoutUserListError = '';
        },
        setHandoutUserListError: (state, action) => {
            state.handoutUserListLoading = false;
            state.handoutUserListSuccess = [];
            state.handoutUserListError = action.payload.message;
        },

        setHandoutDetailsLoading: (state, action) => {
            state.handoutUserDetailsLoading = true
        },
        setHandoutDetailsSuccess: (state, action) => {
            state.handoutUserDetailsLoading = false
            state.handoutUserDetailsSuccess = action.payload.data
            state.handoutUserDetailsError = ""

        },
        setHandoutDetailsError: (state, action) => {
            state.handoutUserDetailsLoading = false
            state.handoutUserDetailsSuccess = {}
            state.handoutUserDetailsError = action.payload.message

        },

        setGetHandoutUserLoading: (state, action) => {
            state.getHandoutUserLoading = true;
            state.getHandoutUserSuccess = {};
            state.getHandoutUserError = '';
        },
        setGetHandoutUserSuccess: (state, action) => {
            state.getHandoutUserLoading = false;
            state.getHandoutUserSuccess = action.payload.data;
            state.getHandoutUserError = '';
        },
        setGetHandoutUserError: (state, action) => {
            state.getHandoutUserLoading = false;
            state.getHandoutUserSuccess = {};
            state.getHandoutUserError = action.payload;
        },
        setCreateHandoutUserLoading: (state, action) => {
            state.createHandoutUserLoading = true;
            state.createHandoutUserSuccess = {};
            state.createHandoutUserError = '';
        },
        setCreateHandoutUserSuccess: (state, action) => {
            state.createHandoutUserLoading = false;
            state.createHandoutUserSuccess = action.payload;
            state.createHandoutUserError = '';
        },
        setCreateHandoutUserError: (state, action) => {
            state.createHandoutUserLoading = false;
            state.createHandoutUserSuccess = {};
            state.createHandoutUserError = action.payload;
        },

        //
        setCourseHandoutListLoading: (state, action) => {
            state.courseHandoutListLoading = true;
            state.courseHandoutListSuccess = {}
            state.courseHandoutListError = ""
        },
        setCourseHandoutListSuccess: (state, action) => {
            state.courseHandoutListLoading = false;
            state.courseHandoutListSuccess = action.payload
            state.courseHandoutListError = ""
        },
        setCourseHandoutListError: (state, action) => {
            state.courseHandoutListLoading = false;
            state.courseHandoutListSuccess = {}
            state.courseHandoutListError = action.payload.message
        },
        setReviewHandoutListLoading: (state, action) => {
            state.reviewHandoutListLoading = true;
            state.reviewHandoutListSuccess = {}
            state.reviewHandoutListError = ""
        },
        setReviewHandoutListSuccess: (state, action) => {
            state.reviewHandoutListLoading = false;
            state.reviewHandoutListSuccess = action.payload
            state.reviewHandoutListError = ""
        },
        setReviewHandoutListError: (state, action) => {
            state.reviewHandoutListLoading = false;
            state.reviewHandoutListSuccess = {}
            state.reviewHandoutListError = action.payload.message
        },
        setAdminUserList: (state, action) => {
            state.adminUserList = action.payload.data.map((item) => ({ ...item, label: item.name, value: item.userId }))
        },

        setCourseHandout: (state, action) => {
            state.courseByHandoutList = action.payload.data.map((item) => ({ ...item, label: item.title, value: item.id }))
        },

        setCourseHandoutDetailsLoading: (state, action) => {
            state.courseHandoutDetailsLoading = true;
            state.courseHandoutDetailsSuccess = {};
            state.courseHandoutDetailsError = "";
        },

        setCourseHandoutDetailsSuccess: (state, action) => {
            state.courseHandoutDetailsLoading = false;
            state.courseHandoutDetailsSuccess = action.payload.data.courseHandout;
            state.courseHandoutStatusList = action.payload.data.contentStatus.map((item) => ({ ...item, value: item.id, label: item.title }))
            state.courseHandoutDetailsError = "";
        },
        setCourseHandoutDetailsError: (state, action) => {
            state.courseHandoutDetailsLoading = false;
            state.courseHandoutDetailsSuccess = {}
            state.courseHandoutDetailsError = action.payload.message
        },

        setHandoutViewLoading: (state, action) => {
            state.handoutViewLoading = true
        },

        setHandoutViewSuccess: (state, action) => {
            state.handoutViewLoading = false
            state.handoutViewSuccess = action.payload.data.courseHandout;
            state.courseHandoutStatusList = action.payload.data.contentStatus.map((item) => ({ ...item, value: item.id, label: item.title }))
        },

        setHandoutViewError: (state, action) => {
            state.handoutViewLoading = false
            state.handoutViewSuccess = {}
            state.handoutViewError = action.payload.message
        }


    },
})

export const {
    setCreateHandoutUserLoading, setCreateHandoutUserSuccess,
    setCreateHandoutUserError,
    setHandoutUserListLoading,
    setHandoutUserListSuccess,
    setHandoutUserListError,
    setGetHandoutUserLoading,
    setGetHandoutUserSuccess,
    setGetHandoutUserError,
    setCourseHandoutListLoading,
    setCourseHandoutListSuccess,
    setCourseHandoutListError,
    setReviewHandoutListLoading,
    setReviewHandoutListSuccess,
    setReviewHandoutListError,
    setAdminUserList,
    setHandoutDetailsLoading,
    setHandoutDetailsSuccess,
    setHandoutDetailsError,
    resetHandoutuserDetails,
    setCourseHandout,
    setCourseHandoutDetailsLoading,
    setCourseHandoutDetailsSuccess,
    setCourseHandoutDetailsError,
    setHandoutViewLoading,
    setHandoutViewSuccess,
    setHandoutViewError




} = handoutUserSlice.actions

export default handoutUserSlice.reducer;